import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "stamp"]
  static values = { 
    token: String,
    confirmUrl: String
  }

  connect() {
    this.checkStatus()
  }

  checkStatus() {
    if (this.hasStampTarget && this.stampTarget.dataset.confirmed === "true") {
      if (this.hasButtonTarget) {
        this.buttonTarget.style.display = "none"
      }
      this.stampTarget.style.display = "block"
    }
  }

  async confirm(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const originalText = button.textContent
    
    button.disabled = true
    button.textContent = "Confirming..."
    
    try {
      const response = await fetch(this.confirmUrlValue, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          document_template: {
            confirm_original: "true"
          }
        })
      })

      if (response.ok) {
        const data = await response.json()
        
        if (data.success) {
          button.style.display = "none"
          
          if (this.hasStampTarget) {
            this.stampTarget.style.display = "block"
            this.stampTarget.textContent = "ORIGINAL"
          }
          
          window.location.reload()
        } else {
          throw new Error(data.error || "Failed to confirm as original")
        }
      } else {
        throw new Error("Network response was not ok")
      }
    } catch (error) {
      console.error("Error confirming original:", error)
      button.disabled = false
      button.textContent = originalText
      alert("Failed to confirm as original. Please try again.")
    }
  }
}